type GetroEventType = 'companyBuilder' | 'navigate';
type GetroEventAction = 'project:created' | 'project:deleted' | 'project:updated' | 'view:network-contacts';

export const emitGetroEvent = (type: GetroEventType, action: GetroEventAction, data: Record<string, unknown>) => {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type, action, data }, '*');
  }
};
